import { PropsWithChildren, useState } from "react";

import { Button, ButtonProps } from "@material-ui/core";
import {
  DialogWithActions,
  DialogWithActionsProps,
} from "../dialog_with_actions";

export type ButtonWithDialogProps = {
  buttonProps: Omit<ButtonProps, "onClick">;
  dialogProps: Omit<DialogWithActionsProps, "open" | "setOpen">;
} & PropsWithChildren<{}>;
export function ButtonWithDialog(props: ButtonWithDialogProps) {
  const { buttonProps, dialogProps, children } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button {...buttonProps} onClick={() => setOpen(true)}>
        {buttonProps.children}
      </Button>
      <DialogWithActions {...dialogProps} open={open} setOpen={setOpen}>
        {children}
      </DialogWithActions>
    </>
  );
}
